import { Contact } from './types'

export function getFullName(contact: Contact): string {
  return `${contact.last_name}${contact.first_name}`
}

export function getPhoneticFullName(contact: Contact): string {
  return `${contact.phonetic_last_name}${contact.phonetic_first_name}`
}

export function getFullAddress(contact: Contact): string {
  return `${contact.region}${contact.locality}${contact.street_address}`
}
